import { IconVideoWithBackground } from "jitsi/base/icons/svg";
import BaseVideoMuteButton from "jitsi/base/toolbox/components/BaseVideoMuteButton";
export class IISightBaseVideoMuteButton extends BaseVideoMuteButton {
    icon = IconVideoWithBackground;
}
